import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

export const OrderOverview = ({dbBook, soldBook, apiBook}) => {

  const navigate = useNavigate()

  return (
    <div className="flex flex-col gap-5 shadow-lg p-10 w-full box-border">
        <h2 className="text-sm md:text-base font-bold">Produktdetaljer</h2>
        <div className="flex gap-5 flex-col lg:flex-row h-full">
            <div className="h-auto w-full lg:w-fit bg-neutral-100 content-center">
              <div className="bookImage aspect-square mx-auto w-40 h-auto bg-neutral-100">
                  <img src={`https://firebasestorage.googleapis.com/v0/b/bolig2.appspot.com/o/${dbBook['_id']}%2F0?alt=media`} alt='BOOK' className="m-auto h-full object-contain bg-neutral-100" />
              </div>
            </div>
            <div className="bookInfo sm:flex-[1.5]">
                <div className="praktisk flex flex-col gap-5">
                    <div className="title">
                        <h1 className="text-sm xl:text-base font-semibold">{apiBook.title}</h1>
                        <p className="text-sm xl:text-base text-gray-700 font-medium">{apiBook.version}</p>
                    </div>
                    <p className="text-sm xl:text-base text-gray-700 font-normal">Forfatter:
                      {(typeof apiBook.director !== 'undefined') ? 
                        apiBook.director.length > 0 ?
                          <span className="italic font-normal">
                              {apiBook.director.map((dir, index) => {
                                if (index !== 0) {
                                    return `, ${dir['$']}`
                                } else {
                                    return ` ${dir['$']}`
                                }
                              })}
                          </span>
                        :
                          <span className="font-normal"> Ukendt forfatter</span>
                      :
                        " Loading..."}
                    </p>
                    <p className="text-sm xl:text-base text-gray-700 font-medium">ISBN:
                      <span className="font-normal">
                        {(typeof apiBook.isbn !== 'undefined') ? 
                          " " + apiBook.isbn
                        : "Loading..."}
                      </span>
                    </p>
                </div>
            </div>
        </div>
        <hr></hr>
        <div>
            <div className="overview flex flex-col gap-y-2">
                <div className="font-normal">
                    <div className="flex border-box">
                        <p className="grow">Solgt for</p>
                        <p>{(Number(dbBook.price) / 100).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                    </div>
                    <div className="flex border-box">
                        <p className="grow">Gebyr</p>
                        <p>- {((Number(dbBook.price) / 100) * 0.05).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                    </div>
                </div>
                <div className="total">
                    {(dbBook.status !== 7 && dbBook.status !== 8) ?
                        <>
                            <div className="flex border-box font-bold">
                                <p className="grow">Overføres til saldo</p>
                                <p>{((Number(dbBook.price) / 100)-(Number(dbBook.price) / 100) * 0.05).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                            </div>
                            <h2 className="text-sm"><span className="font-semibold">BEMÆRK!</span> <span className="italic">Øverføres først når pakken er modtaget af køber</span></h2>
                        </>
                    :
                        <>
                            <div className="flex border-box font-bold">
                                <p className="grow">Overført til saldo</p>
                                <p>{((Number(dbBook.price) / 100)-(Number(dbBook.price) / 100) * 0.05).toFixed(2).toString().replace(/\./g, ',')} kr.</p>
                            </div>
                            <h2 className="ml-auto w-fit"><span className="underline text-emerald-600 cursor-pointer" onClick={() => navigate('/dashboard/saldo')}>Se saldo</span></h2>
                        </>
                    }
                </div>
            </div>
        </div>
    </div>
  )
}